<div id="reunion-popup" class="common-company-popup popup-md">
    <form class="form" role="form" autocomplete="off" [formGroup]="reunionForm">
        <div class="popoup-hearder">
            <h2 class="m-b-5" mat-dialog-title>Reunión con SME</h2>
        </div>
        <div class="popoup-content">
            <div class="block-looper">
                <div class="form-wrap w20">
                    <mat-label aria-label="" class="label">Fecha</mat-label>
                    <mat-form-field appearance="fill">
                        <input matInput [matDatepicker]="picker" formControlName="Fecha">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                    <mat-error *ngIf="reunionForm.get('Fecha').invalid && reunionForm.get('Fecha').touched">
                        <span *ngIf="reunionForm.get('Fecha').hasError('required')">La fecha es obligatoria</span>
                    </mat-error>
                </div>                
                <div class="form-wrap w50">
                    <mat-label aria-label="" class="label">Horas</mat-label>
                    <mat-form-field appearance="fill">
                        <input type="text" matInput formControlName="Horas" appSpanishNumber>
                    </mat-form-field>
                </div>

                <div class="f-w">
                    <div class="form-wrap w50">
                        <mat-label aria-label="" class="label">H. Desplazamiento</mat-label>
                        <mat-form-field appearance="fill">
                            <input type="text" matInput formControlName="HorasDesplazamiento" appSpanishNumber>
                        </mat-form-field>
                    </div>

                    <div class="form-wrap w40">
                        <mat-label aria-label="" class="label">Médico</mat-label>
                        <mat-form-field appearance="fill">
                            <mat-select formControlName="MedicoId">
                                <mat-option>Seleccione</mat-option>
                                <mat-option *ngFor="let doctor of activeDoctorList" [value]="doctor.value">
                                    {{ doctor.viewValue }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="form-wrap w50">
                    <mat-label aria-label="" class="label">Asunto</mat-label>
                    <mat-form-field appearance="fill">
                        <input type="text" matInput formControlName="Asunto"  maxlength="200">
                    </mat-form-field>
                </div>
                <div class="form-wrap w50">
                    <mat-label aria-label="" class="label">Asistentes</mat-label>
                    <mat-form-field appearance="fill">
                        <input type="text" matInput formControlName="Asistentes"  maxlength="200">
                    </mat-form-field>
                </div>
                <div class="form-wrap">
                    <mat-label aria-label="" class="label">Comentarios</mat-label>
                    <mat-form-field appearance="fill">
                        <textarea matInput placeholder="" rows="4" formControlName="Comentarios"></textarea>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="popoup-footer">
            <button class="keep" (click)="onSubmit()"><span class="mat-button-wrapper">Guardar</span></button>
            <button class="cancel" (click)="cancel(false)"><span class="mat-button-wrapper">Cancelar</span></button>
        </div>
    </form>
</div>